import React from 'react';
import classnames from 'classnames';
import { __ } from '@wordpress/i18n';
import { useBoundStore } from '../store/store';

export function Banners() {
	const { banners, removeBanner } = useBoundStore();

	return (
		<>
			{banners.map((banner) => (
				<div
					className={classnames({
						alert: true,
						gforms_note_success: banner.type === 'success',
						gforms_note_error: banner.type === 'error',
					})}
					role="alert"
					key={banner.uuid}
				>
					<p>{banner.content}</p>
					<button
						type="button"
						className="notice-dismiss"
						onClick={() => removeBanner(banner)}
					>
						<span className="screen-reader-text">
							{__(
								'Dismiss this notice.',
								'gp-conditional-pricing'
							)}
						</span>
					</button>
				</div>
			))}
		</>
	);
}
